// Stato condiviso a livello di modulo (una tab = un modulo) per il refresh
// dell'access token: una sola promise in volo e una sola chiusura di sessione.

import jwt_decode from "jwt-decode";

let inFlight = null;
let sessionEnded = false;
let currentAccessToken = null;

// Tutti i chiamanti (interceptor, PersistentLogin, socket) ricevono la stessa
// promise finche' e' in volo. Azzerata in finally: successo ed errore.
export const sharedRefresh = (run) => {
  if (!inFlight) {
    inFlight = run().finally(() => {
      inFlight = null;
    });
  }
  return inFlight;
};

// Esegue teardown una sola volta finche' non viene emesso un nuovo access token.
export const endSessionOnce = (teardown) => {
  if (sessionEnded) return false;
  sessionEnded = true;
  teardown();
  return true;
};

export const isSessionEnded = () => sessionEnded;

// Da chiamare quando la tab ottiene un access token valido (login o refresh).
export const resetSessionEnded = () => {
  sessionEnded = false;
};

// Access token corrente della tab, aggiornato in modo sincrono da
// AuthProvider.setAuth (login, refresh, impersonazione, logout): a differenza
// di `auth` nel ref di un hook non aspetta il render successivo. null se non
// ancora impostato da setAuth (token letto da sessionStorage all'avvio).
export const noteAuth = (value) => {
  currentAccessToken = value?.accessToken || null;
  if (currentAccessToken) resetSessionEnded();
};

export const getCurrentAccessToken = () => currentAccessToken;

const ACCESS_TOKEN_SKEW_MS = 5000;

// Controllo locale della scadenza (solo `exp`, nessuna verifica di firma).
export const isAccessTokenValid = (token) => {
  try {
    const exp = jwt_decode(token)?.exp;
    return !!exp && exp * 1000 > Date.now() + ACCESS_TOKEN_SKEW_MS;
  } catch {
    return false;
  }
};
